import AboutTheRegulationsIcon from "@/components/icons/AboutTheRegulationsIcon";
import AboutTheWcaIcon from "@/components/icons/AboutTheWcaIcon";
import AdminResultsIcon from "@/components/icons/AdminResultsIcon";
import AllCompsIcon from "@/components/icons/AllCompsIcon";
import BookmarkIcon from "@/components/icons/BookmarkIcon";
import CloneIcon from "@/components/icons/CloneIcon";
import CompNotStartedIcon from "@/components/icons/CompNotStartedIcon";
import CompRegoClosedIcon from "@/components/icons/CompRegoClosedIcon";
import CompRegoClosedRedIcon from "@/components/icons/CompRegoClosed_redIcon";
import CompRegoFullButOpenIcon from "@/components/icons/CompRegoFullButOpenIcon";
import CompRegoFullButOpenOrangeIcon from "@/components/icons/CompRegoFullButOpen_orangeIcon";
import CompRegoNotFullOpenIcon from "@/components/icons/CompRegoNotFullOpenIcon";
import CompRegoNotFullOpenGreenIcon from "@/components/icons/CompRegoNotFullOpen_greenIcon";
import CompRegoNotOpenYetIcon from "@/components/icons/CompRegoNotOpenYetIcon";
import CompRegoNotOpenYetGreyIcon from "@/components/icons/CompRegoNotOpenYet_greyIcon";
import CompRegoOpenDateIcon from "@/components/icons/CompRegoOpenDateIcon";
import CompRegoCloseDateIcon from "@/components/icons/CompRegoCloseDateIcon";
import CompetitorsIcon from "@/components/icons/CompetitorsIcon";
import ContactIcon from "@/components/icons/ContactIcon";
import DelegateReportIcon from "@/components/icons/DelegateReportIcon";
import DetailsIcon from "@/components/icons/DetailsIcon";
import DeveloperExportIcon from "@/components/icons/DeveloperExportIcon";
import DisciplinaryLogIcon from "@/components/icons/DisciplinaryLogIcon";
import DisclaimerIcon from "@/components/icons/DisclaimerIcon";
import DownloadIcon from "@/components/icons/DownloadIcon";
import EditIcon from "@/components/icons/EditIcon";
import EducationalResourcesIcon from "@/components/icons/EducationalResourcesIcon";
import ErrorIcon from "@/components/icons/ErrorIcon";
import ExternalLinkIcon from "@/components/icons/ExternalLinkIcon";
import FacebookIcon from "@/components/icons/FacebookIcon";
import FiltersIcon from "@/components/icons/FiltersIcon";
import GitHubIcon from "@/components/icons/GithubIcon";
import GuidelinesIcon from "@/components/icons/GuidelinesIcon";
import HelpAndFaqsIcon from "@/components/icons/HelpAndFaqsIcon";
import IncidentsLogIcon from "@/components/icons/IncidentsLogIcon";
import InformationIcon from "@/components/icons/InformationIcon";
import InstagramIcon from "@/components/icons/InstagramIcon";
import LanguageIcon from "@/components/icons/LanguageIcon";
import ListIcon from "@/components/icons/ListIcon";
import LocationIcon from "@/components/icons/LocationIcon";
import ManageTabsIcon from "@/components/icons/ManageTabsIcon";
import MapIcon from "@/components/icons/MapIcon";
import MediaSubmissionIcon from "@/components/icons/MediaSubmissionIcon";
import MenuIcon from "@/components/icons/MenuIcon";
import MultimediaIcon from "@/components/icons/MultimediaIcon";
import MyCompsIcon from "@/components/icons/MyCompsIcon";
import MyResultsIcon from "@/components/icons/MyResultsIcon";
import NationalChampionshipIcon from "@/components/icons/NationalChampionshipIcon";
import NewCompIcon from "@/components/icons/NewCompIcon";
import OnTheSpotRegistrationIcon from "@/components/icons/OnTheSpotRegistrationIcon";
import PaymentIcon from "@/components/icons/PaymentIcon";
import PrivacyIcon from "@/components/icons/PrivacyIcon";
import RankingsIcon from "@/components/icons/RankingsIcon";
import RecordsIcon from "@/components/icons/RecordsIcon";
import RegionalOrganisationsIcon from "@/components/icons/RegionalOrganisationsIcon";
import RegisterIcon from "@/components/icons/RegisterIcon";
import RegistrationIcon from "@/components/icons/RegistrationIcon";
import RegulationsAndGuidelinesIcon from "@/components/icons/RegulationsAndGuidelinesIcon";
import RegulationsHistoryIcon from "@/components/icons/RegulationsHistoryIcon";
import RegulationsIcon from "@/components/icons/RegulationsIcon";
import ResultsExportIcon from "@/components/icons/ResultsExportIcon";
import ScramblesIcon from "@/components/icons/ScramblesIcon";
import SearchIcon from "@/components/icons/SearchIcon";
import SpectatorsIcon from "@/components/icons/SpectatorsIcon";
import SpeedcubingHistoryIcon from "@/components/icons/SpeedcubingHistoryIcon";
import SpotsLeftIcon from "@/components/icons/SpotsLeftIcon";
import StatisticsIcon from "@/components/icons/StatisticsIcon";
import TeamsCommitteesAndCouncilsIcon from "@/components/icons/TeamsCommitteesAndCouncilsIcon";
import ToolsIcon from "@/components/icons/ToolsIcon";
import TranslatorsIcon from "@/components/icons/TranslatorsIcon";
import TwitchIcon from "@/components/icons/TwitchIcon";
import UserIcon from "@/components/icons/UserIcon";
import UsersPersonsIcon from "@/components/icons/UsersPersonsIcon";
import VenueIcon from "@/components/icons/VenueIcon";
import WcaDelegatesIcon from "@/components/icons/WcaDelegatesIcon";
import WcaDocsIcon from "@/components/icons/WcaDocsIcon";
import WcaLiveIcon from "@/components/icons/WcaLiveIcon";
import WcaLogoIcon from "@/components/icons/WcaLogoIcon";
import WcaOfficersAndBoardIcon from "@/components/icons/WcaOfficersAndBoardIcon";
import WeiboIcon from "@/components/icons/WeiboIcon";
import XIcon from "@/components/icons/XIcon";
import YouTubeIcon from "@/components/icons/YoutubeIcon";
import _222Icon from "@/components/icons/events/_222Icon";
import _333bfIcon from "@/components/icons/events/_333bfIcon";
import _333fmIcon from "@/components/icons/events/_333fmIcon";
import _333ftIcon from "@/components/icons/events/_333ftIcon";
import _333Icon from "@/components/icons/events/_333Icon";
import _333mbfIcon from "@/components/icons/events/_333mbfIcon";
import _333ohIcon from "@/components/icons/events/_333ohIcon";
import _333mboIcon from "@/components/icons/events/_333mboIcon";
import _444bfIcon from "@/components/icons/events/_444bfIcon";
import _444Icon from "@/components/icons/events/_444Icon";
import _555bfIcon from "@/components/icons/events/_555bfIcon";
import _555Icon from "@/components/icons/events/_555Icon";
import _666Icon from "@/components/icons/events/_666Icon";
import _777Icon from "@/components/icons/events/_777Icon";
import _ClockIcon from "@/components/icons/events/_ClockIcon";
import _FtoIcon from "@/components/icons/events/_FtoIcon";
import _MagicIcon from "@/components/icons/events/_MagicIcon";
import _MinxIcon from "@/components/icons/events/_MinxIcon";
import _MmagicIcon from "@/components/icons/events/_MmagicIcon";
import _PyramIcon from "@/components/icons/events/_PyramIcon";
import _SkewbIcon from "@/components/icons/events/_SkewbIcon";
import _Sq1Icon from "@/components/icons/events/_Sq1Icon";

export const iconMap = {
  "About the Regulations": AboutTheRegulationsIcon,
  "About the WCA": AboutTheWcaIcon,
  "Admin Results": AdminResultsIcon,
  "All Competitions": AllCompsIcon,
  Bookmark: BookmarkIcon,
  Clone: CloneIcon,
  "Competition Not Started": CompNotStartedIcon,
  "Registration Closed": CompRegoClosedIcon,
  "Registration Closed (Red)": CompRegoClosedRedIcon,
  "Registration Full but Open": CompRegoFullButOpenIcon,
  "Registration Full but Open (Orange)": CompRegoFullButOpenOrangeIcon,
  "Registration Not Full, Open": CompRegoNotFullOpenIcon,
  "Registration Not Full, Open (Green)": CompRegoNotFullOpenGreenIcon,
  "Registration Not Open Yet": CompRegoNotOpenYetIcon,
  "Registration Not Open Yet (Grey)": CompRegoNotOpenYetGreyIcon,
  "Registration Open Date": CompRegoOpenDateIcon,
  "Registration Close Date": CompRegoCloseDateIcon,
  Competitors: CompetitorsIcon,
  Contact: ContactIcon,
  "Delegate Report": DelegateReportIcon,
  Details: DetailsIcon,
  "Developer Export": DeveloperExportIcon,
  "Disciplinary Log": DisciplinaryLogIcon,
  Disclaimer: DisclaimerIcon,
  Download: DownloadIcon,
  Edit: EditIcon,
  "Educational Resources": EducationalResourcesIcon,
  Error: ErrorIcon,
  "External Link": ExternalLinkIcon,
  Facebook: FacebookIcon,
  Filters: FiltersIcon,
  GitHub: GitHubIcon,
  Guidelines: GuidelinesIcon,
  "Help and FAQs": HelpAndFaqsIcon,
  "Incidents Log": IncidentsLogIcon,
  Information: InformationIcon,
  Instagram: InstagramIcon,
  Language: LanguageIcon,
  List: ListIcon,
  Location: LocationIcon,
  "Manage Tabs": ManageTabsIcon,
  Map: MapIcon,
  "Media Submission": MediaSubmissionIcon,
  Menu: MenuIcon,
  Multimedia: MultimediaIcon,
  "My Competitions": MyCompsIcon,
  "My Results": MyResultsIcon,
  "National Championship": NationalChampionshipIcon,
  "New Competition": NewCompIcon,
  "On-the-Spot Registration": OnTheSpotRegistrationIcon,
  Payment: PaymentIcon,
  Privacy: PrivacyIcon,
  Rankings: RankingsIcon,
  Records: RecordsIcon,
  "Regional Organisations": RegionalOrganisationsIcon,
  Register: RegisterIcon,
  Registration: RegistrationIcon,
  "Regulations and Guidelines": RegulationsAndGuidelinesIcon,
  "Regulations History": RegulationsHistoryIcon,
  Regulations: RegulationsIcon,
  "Results Export": ResultsExportIcon,
  Scrambles: ScramblesIcon,
  Search: SearchIcon,
  Spectators: SpectatorsIcon,
  "Speedcubing History": SpeedcubingHistoryIcon,
  "Spots Left": SpotsLeftIcon,
  Statistics: StatisticsIcon,
  "Teams, Committees and Councils": TeamsCommitteesAndCouncilsIcon,
  Tools: ToolsIcon,
  Translators: TranslatorsIcon,
  Twitch: TwitchIcon,
  User: UserIcon,
  "Users / Persons": UsersPersonsIcon,
  Venue: VenueIcon,
  "WCA Delegates": WcaDelegatesIcon,
  "WCA Documents": WcaDocsIcon,
  "WCA Live": WcaLiveIcon,
  "WCA Logo": WcaLogoIcon,
  "WCA Officers and Board": WcaOfficersAndBoardIcon,
  Weibo: WeiboIcon,
  "X (formerly Twitter)": XIcon,
  YouTube: YouTubeIcon,
  "222Icon": _222Icon,
  "333bfIcon": _333bfIcon,
  "333fmIcon": _333fmIcon,
  "333ftIcon": _333ftIcon,
  "333Icon": _333Icon,
  "333mbfIcon": _333mbfIcon,
  "333ohIcon": _333ohIcon,
  "333mboIcon": _333mboIcon,
  "444bfIcon": _444bfIcon,
  "444Icon": _444Icon,
  "555bfIcon": _555bfIcon,
  "555Icon": _555Icon,
  "666Icon": _666Icon,
  "777Icon": _777Icon,
  ClockIcon: _ClockIcon,
  FtoIcon: _FtoIcon,
  MagicIcon: _MagicIcon,
  MinxIcon: _MinxIcon,
  MmagicIcon: _MmagicIcon,
  PyramIcon: _PyramIcon,
  SkewbIcon: _SkewbIcon,
  Sq1Icon: _Sq1Icon,
} as const;

export type IconName = keyof typeof iconMap;
